module.exports = function(req, res, next) {
  const path = req.url;
  const sanitizedPath = path.replace(/\/{2,}/g, '/'); // remove double slashes from url
  if (sanitizedPath !== path) {
    res.writeHead(301, { Location: sanitizedPath });
    res.end();
  } else {
    next();
  }
};
